import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Redirect, withRouter} from 'react-router-dom';
import AdminHome from '../components/admin-home';
import HomeRedesign from '../components/home-redesign';
import {ROLES} from '../constants';

export const RoleHome = ({token, profile}) => {
  if (token === null) {
    return <Redirect to="/login"/>;
  }

  if (!profile || !profile.user) {
    return null;
  }

  if (profile.user.role === ROLES.partner) {
    return <Redirect to="/partner-fields"/>;
  }

  if (profile.user.role === ROLES.admin) {
    return <AdminHome/>;
  }

  return <HomeRedesign/>;
};

RoleHome.propTypes = {
  token: PropTypes.string,
  profile: PropTypes.object
};

RoleHome.defaultProps = {
  token: null,
  profile: null
};

export default withRouter(connect(
  ({login: {token, profile}}) => ({token, profile}),
  null
)(RoleHome));
